import { Any } from "@cede/types";

export type LoggerColors = "ERROR" | "WARNING" | "INFO" | "SUCCESS";

export type LoggerMessageType = {
  color: string;
  type: string;
};

export interface LoggerType {
  log(message: string, type: LoggerMessageType): void;
  error(e: Any): void;
  enableVerbose?(): void;
}
